export function codeToChangeString(item) {
  //支付状态Code转名称 支付状态-动态style
    switch (item.bizState) {
      case 10:
        item.stateColor = 'orange';
        item.bizState = '待支付';
        item.changeId = 1;
        item.payState = 0;
        item.payName = '等待支付'
        break;
      case 20:
        item.stateColor = 'orange';
        item.bizState = '待发货';
        item.changeId = 3;
        item.payState = 1;
        item.payName = '等待发货'
        break;
      case 25:
        item.stateColor = 'orange';
        item.bizState = '部分发货';
        item.changeId = 2;
        item.payState = 2;
        item.payName = '等待收货'
        break;
      case 99:
        item.stateColor = 'green';
        item.bizState = '交易完成';
        item.changeId = 5;
        item.payState = 3;
        break;
      case 0:
        item.stateColor = 'red';
        item.bizState = '交易关闭';
        item.changeId = 6;
        item.payState = 3;
        break;
      case 11:
        item.stateColor = 'orange';
        item.bizState = '取消订单申请中';
        break;
      case 30:
        item.stateColor = 'green';
        item.bizState = '已发货';
        item.changeId = 4;
        item.payState = 2;
        item.payName = '等待收货'
        break;
      default:
    }
}
